import React from 'react';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
import { offer } from '../data/offer';
export function FinalCTASection() {
  return <section className="bg-brand-ocean px-4 py-20 text-white md:py-24" data-id="element-66" data-mp="3s0bo6uw34dgx">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-67" data-mp="vd04j6bn25x">
        <h2 className="text-3xl font-extrabold leading-[1.1] md:text-4xl" data-id="element-68" data-mp="2ze0n7j4kgajl">
          Smetti di improvvisare: porta GEOGRAFIA PRONTA™ in classe oggi stesso
        </h2>

        <p className="mt-8 flex items-baseline justify-center gap-3" data-id="element-69" data-mp="34a8wwgzzvbjd">
          <span className="font-display text-6xl font-extrabold tracking-tight" data-id="element-70" data-mp="39a3rovmw4l9p">{offer.todayPrice}</span>
          <span className="text-lg font-bold text-white/60 line-through" data-id="element-71" data-mp="3e3prhn7yguo3">{offer.totalValue}</span>
        </p>

        <ul className="mx-auto mt-8 grid max-w-xl gap-2 text-left" data-id="element-72" data-mp="2gkwq1ns53fk8">
          {bonuses.map(({
          title
        }) => <li key={title} className="flex items-start gap-3 rounded-xl bg-white/10 px-4 py-3 text-sm" data-id="element-73" data-mp="2ljr8upq3x44c">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-amber" strokeWidth={3} aria-hidden="true" data-id="element-74" data-mp="21vxt9dpfontr" />
              <span className="font-semibold leading-snug" data-id="element-75" data-mp="1x4xus40o1xp5">{title}</span>
            </li>)}
        </ul>

        <CTAButton className="mt-8 w-full py-4 sm:w-auto sm:px-10" data-id="element-76" data-mp="1s6wdnomsw8gb">Acquista adesso con pagamento unico</CTAButton>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] font-semibold text-white/75" data-id="element-77" data-mp="1o5aujljoaxxo">
          <li className="flex items-center gap-1.5" data-id="element-78" data-mp="1j7j46vyofjvl">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-79" data-mp="1e5k17n6umoz6" />
            Pagamento sicuro
          </li>
          <li className="flex items-center gap-1.5" data-id="element-80" data-mp="198bqu8rxzp8h">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-81" data-mp="38ke6f7xg3zgv" />
            Accesso immediato
          </li>
        </ul>
      </Reveal>
    </section>;
}